import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

export const addEditAdditionalExpensesModalSchema = yupResolver(
  yup.object({
    accountDescription: yup.string().required('Descrição da conta é obrigatória'),
    accountNumber: yup.string().required('Número da conta é obrigatório'),
    additionalExpensesValue: yup.string().required('Valor da despesa adicional é obrigatório'),
    observations: yup.string().required('Observações é obrigatória')
  })
)
